import useDeleteApi from './useDeleteApi';
import { url } from '../../utils/confserveur';

export const useDeleteEleveFromGroup = () => {
  const { deleteData, isLoading, error } = useDeleteApi();

  // Nouvelle fonction deleteEleve qui prend à la fois eleveId et groupeId
  const deleteEleveFromGroup = async (eleveId, groupeId) => {
    const params = new URLSearchParams();
    params.append('eleve_id', eleveId);
    params.append('groupe_id', groupeId);
  
    // Construire l'URL avec les paramètres
    const urldelete = `${url}groupes/remove-eleve/?${params.toString()}`;
  
    // Appeler deleteData avec l'URL générée
    await deleteData(urldelete);
  };

  return { deleteEleveFromGroup, isLoading, error };
};